import React from 'react';
import { ClipLoader } from "react-spinners";

const Loading = ({ isFetching, size, color, style = {}}) => {

    return (
        <div style={style}>
            <ClipLoader
                sizeUnit={"px"}
                size={size || 30}
                color={color || '#0F70B7'}
                loading={isFetching}
            />
        </div>
    );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js